import { Page } from "@/models/page-models/Page";

export const SalesRmAlias: Page = {
  "path": "sales-rm-aliases",
  "name": "Sales RM Alias",
  "props": {
    "data": {
      "title": "Sales RM Alias",
      "printable": "FALSE",
      "url": "rm-aliases",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Sales RM Alias",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openSalesRmAliasPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Create New Sales Alias"
                      },
                      "name": "openSalesRmAliasPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "formData",
                  "label": "RM aliases",
                  "disabled": "FALSE",
                  "items": "fetchedData.rmAliases.data",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "ID"
                    },
                    {
                      "value": "__item.alias",
                      "text": "Name"
                    },
                    {
                      "value": "__item.productLine",
                      "text": "RM Family"
                    }
                  ],
                  "tableType": "static",
                  "selectableUniqueId": "_id",
                  "singleSelect": true,
                  "groupActions": [
                    {
                      "label": "Edit",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyRmAlias",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getRmAlias",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.rmAliasToEdit"
                          },
                          "name": "copyRmAlias"
                        },
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyRmAliasId",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item._id",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.selectedRmAlias"
                          },
                          "name": "copyRmAliasId"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "openEditRmAliasPopup",
                            "type": "fnOpenPopup",
                            "arg1Key": "popupName",
                            "arg1Value": "Edit Sales RM Alias"
                          },
                          "name": "openEditRmAliasPopup"
                        }
                      ]
                    },
                    {
                      "label": "Delete",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyRmAliasId",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item._id",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.rmAliasToDelete"
                          },
                          "name": "copyRmAliasId"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "openDeleteRmAliasPopup",
                            "type": "fnOpenPopup",
                            "arg1Key": "popupName",
                            "arg1Value": "Confirm Delete Sales RM Alias"
                          },
                          "name": "openDeleteRmAliasPopup"
                        }
                      ]
                    }
                  ],
                  "enableSearch": true,
                  "neverHideActionBar": true
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Create New Sales Alias",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.rmAliasForm.alias",
                  "label": "Sales RM Alias",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.rmAliasForm.productLine",
                  "label": "RM Family",
                  "disabled": "FALSE",
                  "items": "[\"PSL\",\"Paper\",\"Film\",\"Composite\",\"Board\",\"Non Woven\",\"Fragrance\",\"Ribbon\"]",
                  "dropdownType": "static"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Create",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "createSalesRmAlias",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/rm-alias/insert",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.rmAliasForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "createSalesRmAlias"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closePopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Create New Sales Alias"
                  },
                  "name":"closePopup"
                }
              ]
            }
          ],
          "width": "450"
        },
        {
          "type": "popupGroup",
          "label": "Edit Sales RM Alias",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.rmAliasToEdit.newAlias",
                  "label": "New Sales RM Alias",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Update",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "editSalesRmAlias",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/rm-alias/update/{{fetchedData.selectedRmAlias}}",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.rmAliasToEdit",
                    "arg3Key": "requestMethod",
                    "arg3Value": "PATCH",
                    "arg4Key": "refreshPage",
                    "arg4Value": "TRUE"
                  },
                  "name": "editSalesRmAlias"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closePopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Create New Sales Alias"
                  },
                  "name":"closePopup"
                }
              ]
            }
          ],
          "width": "450"
        },
        {
          "type": "popupGroup",
          "label": "Confirm Delete Sales RM Alias",
          "width": "450",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "labelType": "formula",
                  "formula": "Are you sure?"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Delete",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "deleteRmAlias",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/rm-alias/{{fetchedData.rmAliasToDelete}}/delete",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "DELETE"
                  },
                  "name": "deleteRmAlias"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllRmAliases",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/rm-alias/get",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.rmAliases"
        },
        "name": "getAllRmAliases"
      }
    ],
    "functions": [
      {
        "name": "getRmAlias",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "newAlias": "__selectedObject.alias"
        }
      }
    ]
  },
  "forRole": "COMMERCIAL_MANAGER",
  "visible": true
}